<template>
    <div class="main-container">
        <router-view />
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.main-container {
    // padding-top: 50px;
    // height: calc(100% - 50px);
    height: 100%;
    // background-color: aqua;
}
</style>